import { Reveal } from "@/lib/motion";

const quotes = [
  {
    text: "Visions didn't just build a booth — they built the busiest corner of the entire show floor. Our lead scans tripled year over year.",
    name: "Dana Whitfield",
    role: "VP Marketing, Novasync",
  },
  {
    text: "The custom activation they built for our product launch stopped people mid-aisle. Fully bespoke — LED, interactive product bays, the works. It looked like a flagship store dropped onto the show floor.",
    name: "Marcus Lee",
    role: "Events Director, Helix",
  },
];

export default function Testimonials() {
  return (
    <section id="about" className="border-y border-white/10 bg-[#080808]">
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-10 md:py-40">
        <div className="mb-16 flex items-center gap-3">
          <span className="h-px w-12 bg-[#FF3B30]" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">
            Why teams stay
          </span>
        </div>
        <div className="grid grid-cols-1 gap-16 md:grid-cols-2 md:gap-24">
          {quotes.map((q, i) => (
            <Reveal key={q.name} delay={i * 0.12} className={i === 1 ? "md:mt-24" : ""}>
              <blockquote>
                <p className="font-display text-2xl font-medium leading-snug tracking-tight md:text-4xl">
                  <span className="text-[#FF3B30]">“</span>
                  {q.text}
                  <span className="text-[#FF3B30]">”</span>
                </p>
                <footer className="mt-8 flex items-center gap-4">
                  <span className="h-px w-10 bg-white/30" />
                  <div>
                    <div className="font-mono text-sm">{q.name}</div>
                    <div className="font-mono text-xs uppercase tracking-[0.15em] text-white/40">
                      {q.role}
                    </div>
                  </div>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
